import { useConfigService } from '@completeanatomy/config';
import { useEffect } from 'react';

import { globalVariables } from '../../config/globalVariables';

/**
 * Hook to set up configuration settings for the application.
 * Should be used at the root of the application to ensure
 * that configuration is initialized properly.
 */
export const useConfigSetup = () => {
  const config = useConfigService();

  useEffect(() => {
    if (!config) {
      console.warn(
        'Config service is not available. useConfigSetup requires config service to be initialized.'
      );

      return;
    }

    config.set('applicationId', globalVariables.appId);
    config.set('identifier', 'identifier');
    config.set('AWS_SERVER_BACKEND', globalVariables.caDomain);
    config.set('AWS_SERVER_S3_USERDATA', globalVariables.userData);
    config.set('SSO_BACKEND', globalVariables.ssoDomain);
    config.set('MY_ACCOUNT_LINK', globalVariables.userAccount);
    config.set('pendoApiKey', globalVariables.pendoApiKey);
    config.set('WEB_STORE', globalVariables.caWebStore);
    config.set('pendoTutorialId', globalVariables.pendoTutorialId);
  }, [config]);
};
